import React from 'react';
import { toast } from 'react-toastify';

interface Props {
  children?: string;
  textToCopy?: string | number;
  onClick?: () => void;
  withoutIcon?: boolean;
}

export const CopyToClipboard = (props: Props) => {
  const copy = () => {
    navigator.clipboard.writeText(String(props.textToCopy || props.children)).then(() => {
      toast.info('Copied to clipboard');
    });
  };

  return (
    <span {...props} onClick={props.onClick || copy} style={{ cursor: 'pointer' }} aria-hidden>
      {props.children}
      {props.withoutIcon ? null : ' ❏'}
    </span>
  );
};
